/*
 *
 * campaign reducer
 *
 */
const initialState = {
  id: null,
  campaignLoaderController: false,
  createCampaignController: false,
  updateCampaignController: false,
  count: 0,
  list: [],
  statistics: {
    awaiting: 0,
    progress: 0,
    succeed: 0,
    failed: 0,
    skipped: 0,
    cancelled: 0,
  },
  actions: [],
  singleLoaderPage: true,
};

const campaign = (state = initialState, action) => {
  switch (action.type) {
    case "CAMPAIGN":
      return Object.assign({}, state, {
        ...action.payload,
      });

    case "CAMPAIGN_CONNECT_COUNT":
      return Object.assign({}, state, {
        count: action.payload.count,
      });

    case "UPDATE_CAMPAIGN_CONTROLLER":
      return Object.assign({}, state, {
        updateCampaignController: action.payload.updateCampaignController,
      });

    default:
      return state;
  }
};

export default campaign;
